var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 13C14.5376 13 17 10.3137 17 7C17 3.68629 14.5376 1 11.5 1C8.46243 1 6 3.68629 6 7C6 10.3137 8.46243 13 11.5 13Z",
    stroke: "#9295A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00002 20.4969C2.99849 20.1075 3.08775 19.7228 3.26104 19.3719C3.80484 18.3107 5.33834 17.7482 6.61082 17.4935C7.52853 17.3024 8.45892 17.1747 9.39506 17.1114C11.1282 16.9629 12.8714 16.9629 14.6046 17.1114C15.5407 17.1754 16.471 17.3031 17.3889 17.4935C18.6613 17.7482 20.1948 18.2576 20.7386 19.3719C21.0871 20.0871 21.0871 20.9173 20.7386 21.6325C20.1948 22.7468 18.6613 23.2562 17.3889 23.5003C16.4722 23.6993 15.5415 23.8306 14.6046 23.893C13.1939 24.0097 11.7767 24.031 10.363 23.9567C10.0367 23.9567 9.72133 23.9567 9.39506 23.893C8.46169 23.8314 7.53452 23.7001 6.6217 23.5003C5.33834 23.2562 3.81571 22.7468 3.26104 21.6325C3.08864 21.2776 2.99947 20.8897 3.00002 20.4969Z",
    stroke: "#9295A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5b9a8571bb8489eed6086121842fe5cc.svg";
export { ForwardRef as ReactComponent };